import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private toast: any;
  private readonly defaultErrorMessage = 'An error occurred. Please try again later';

  constructor(private toastCtrl: ToastController) {}

  async showToast(respMsg: string) {
    const errorMsg = respMsg || this.defaultErrorMessage;

    this.dismiss();
    this.toast = await this.toastCtrl.create({
      message: errorMsg,
      position: 'bottom',
      cssClass: 'http-error-msg',
      buttons: [
        {
          text: 'X',
          role: 'cancel',
        },
      ],
    });
    this.toast.present();
  }

  async dismiss() {
    if (this.toast) {
      await this.toast.dismiss();
    }
  }

  showErrorInToast(file, method, error) {
    const msg = `
      file:${file}, method:${method}, error: ${JSON.stringify(error)}
    `;

    //  this.showToast(msg); // Todo only for debug purpose
    console.error(msg);
  }
}
